<template>
  <nav class="navbar navbar-light navbar-laravel custom">
  <!-- <nav class="navbar navbar-expand-md navbar-light navbar-laravel custom"> -->
    <div class="container">
      <router-link to="/" class="navbar-brand"><img :src="require(`@/assets/madelogo.png`)"/></router-link>
      <!-- <router-link to="/" class="navbar-brand">MADE</router-link> -->
      <!-- <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label
      >
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent"> -->
      <div id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <ul class="navbar-nav ml-auto">
          <template v-if="user.loggedIn">
            <!-- <div class="nav-item">{{user.data.displayName}}</div> -->
            <li class="nav-item">
              <a class="nav-link" @click.prevent="signOut">Sign out</a>
            </li>
          </template>
          <template v-else>
            <!-- <li class="nav-item">
              <router-link to="login" class="nav-link">Login</router-link>
            </li>
            <li class="nav-item">
              <router-link to="register" class="nav-link">Register</router-link>
            </li> -->
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
export default {
  computed: {
    ...mapGetters({
// map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "Dashboard"
          });
        });
    }
  }
};
</script>

<style scoped>
.custom {
  /* background-color: # */
  box-shadow: 0px 5px 5px rgba(171,171,171,0.1) !important;
  position: fixed !important;
  width: 100vw !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 10000 !important;
}

img {
  max-height: 20px !important;
}

/* .tab-block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
} */

</style>